import axios from "axios";
import { authRedirectGate } from "../utils/authRedirectGate";

// This project's own backend (separate from grid_v2's).
export const baseURL = process.env.REACT_APP_API_BASE_URL ?? "";

export const baseAxios = axios.create({
  baseURL,
  withCredentials: true,
});

export const defaultAxios = axios.create({
  baseURL,
});

baseAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (authRedirectGate.suppress401Redirect) {
      return Promise.reject(error);
    }
    if (error.response && error.response.status === 401) {
      if (error.config.url !== "/api/whoami/" && error.config.url !== "/api/auth/login/") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);
